import { useReactFlow } from '@xyflow/react'
import { ZoomInIcon, ZoomOutIcon, FitIcon } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'

export function ChatbotPreviewControls() {
  const { t } = useTranslation()
  const { zoomIn, zoomOut, fitView } = useReactFlow()

  return (
    <div className="c-absolute c-top-2 c-right-2 c-bg-white c-border c-border-gray-300 c-rounded c-shadow-sm c-p-2 c-flex c-flex-col c-gap-2 c-z-10">
      <button
        onClick={() => zoomIn()}
        className="c-w-8 c-h-8 c-flex c-items-center c-justify-center c-group"
        type="button"
        aria-label={t('pages.configuration.followups.chatbot.node-editor.zoom-in-aria-label')}
      >
        <ZoomInIcon className="c-w-4 c-h-4 c-text-primary-700 group-hover:c-text-primary-400" />
      </button>
      <button
        onClick={() => zoomOut()}
        className="c-w-8 c-h-8 c-flex c-items-center c-justify-center c-group"
        type="button"
        aria-label={t('pages.configuration.followups.chatbot.node-editor.zoom-out-aria-label')}
      >
        <ZoomOutIcon className="c-w-4 c-h-4 c-text-primary-700 group-hover:c-text-primary-400" />
      </button>
      <button
        onClick={() => fitView()}
        className="c-w-8 c-h-8 c-flex c-items-center c-justify-center c-group"
        type="button"
        aria-label={t('pages.configuration.followups.chatbot.node-editor.fit-view-aria-label')}
      >
        <FitIcon className="c-w-4 c-h-4 c-text-primary-700 group-hover:c-text-primary-400" />
      </button>
    </div>
  )
}
